import { isPlainObject, keys } from 'lodash-es'

const transformer = function (origin, defs) {
  if (isPlainObject(origin)) {
    const keyArr = keys(origin)

    if (keyArr.includes('text')) {
      return {
        render: 'text',
        origin,
        value: origin.text,
        onClick: origin.onClick,
        defs,
      }
    }
    if (keyArr.includes('value')) {
      return {
        render: 'text',
        origin,
        value: origin.value,
        onClick: origin.onClick,
        defs,
      }
    }
  }

  return {
    render: 'text',
    origin,
    value: origin,
    onClick: origin.onClick,
    defs,
  }
}

export default transformer
